import { Row, Col } from 'react-bootstrap';
import './dtb1250.css';
import { useState } from 'react';

const DTB1250Hmi = ({ machineLive = {} }) => {
  const [page, setPage] = useState('HOME');

  const renderPage = () => {
    switch (page) {
      case 'LIMITE':
        return (
          <DTB1250LimiteEtalarePage
            machineLive={machineLive}
            setPage={setPage}
          />
        );
      case 'SETTINGS':
        return (
          <DTB1250SettingsPage machineLive={machineLive} setPage={setPage} />
        );
      case 'HOME':
      default:
        return <DTB1250HomeHmi machineLive={machineLive} setPage={setPage} />;
    }
  };

  return <>{renderPage()}</>;
};

const DTB1250HomeHmi = ({ machineLive = {}, setPage }) => {
  return (
    <div className="dtb-container">
      {/* TOP BAR */}
      <div className="dtb-topbar">
        <div className="dtb-top-item">
          <div className="top-label">VEZI MAX LIN</div>
          <div className="top-value cyan">
            {machineLive.MAX_RAMP_VALUE_PER || '144.0'} m/min
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">VITEZA LIN</div>
          <div className="top-value green">
            {machineLive.ACT_RAMP_VALUE_PER || '2.0'} m/min
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">RĂSUCIRE</div>
          <div className="top-value">
            {machineLive.BOW_ACT_TWIST.toFixed(2) || '0.0'} rot/min
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">CUPLU</div>
          <div className="top-value yellow">
            {machineLive.TORQE_ACT_PERCENTEC || '25.0'} %
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">ETALARE ACT</div>
          <div className="top-value">{machineLive.TRAVERS_ACT_PULS} mm</div>
        </div>

        <div className="dtb-top-item set-box">
          <div className="top-label">SET M</div>
          <div className="top-value yellow">
            {machineLive.SET_METER || '30000.0'}
          </div>

          <div className="set-row">
            <span>ACT M</span>
            <strong>{machineLive.METER_ACT.toFixed(2) || '19763.1'}</strong>
          </div>

          <div className="set-row">
            <span>TOT M</span>
            <strong>{machineLive.METER_TOTAL.toFixed(2) || '19763.1'}</strong>
          </div>
        </div>
      </div>

      {/* MAIN AREA */}
      <Row className="dtb-main">
        {/* STÂNGA */}
        <Col md={2} className="side-col">
          <div className="side-box">
            <div className="side-label">Curent</div>
            <div className="side-value">
              {machineLive.BOW_CURRENT || '0.0'} A
            </div>
          </div>
        </Col>

        {/* CENTRU */}
        <Col md={8} className="center-col">
          {/* LIMITĂ ETALARE */}
          <div className="limit-box">
            <div className="limit-title">LIMITE ETALARE</div>
            <div className="limit-row">
              <span>Stânga</span>
              <strong className="yellow">
                -{machineLive.TRAVERS_LEFT_PULS_LIMIT || '181'}
              </strong>
              <span>Act</span>
              <strong className="cyan">
                {machineLive.TRAVERS_ACT_PULS || '0'}
              </strong>
              <span>Dreapta</span>
              <strong className="yellow">
                {machineLive.TRAVERS_RIGHT_PULS_LIMIT || '157'}
              </strong>
            </div>
          </div>

          {/* ÎNTINDERE */}
          <div className="intindere-card">
            <div className="card-title">ÎNTINDERE ACTUALĂ</div>
            <div className="intindere-value">
              {machineLive.TORQE_ACT_PERCENTEC || '25'} %
            </div>
          </div>
        </Col>

        {/* DREAPTA */}
        <Col md={2} className="side-col">
          <div className="nav-btn" onClick={() => setPage('LIMITE')}>
            Limite Etalare
          </div>

          <div className="nav-btn big-icon" onClick={() => setPage('SETTINGS')}>
            ⚙
          </div>
          <div className="nav-btn warn">⚠</div>
        </Col>
      </Row>

      {/* BOTTOM BAR */}
      <div className="dtb-bottom">
        <div className="bottom-box">
          <div className="bottom-label">LUNGIME PAS</div>
          <div className="bottom-value yellow">
            {machineLive.BOW_LAY_LENGHT || '120.0'} mm
          </div>
        </div>

        <div className="bottom-box">
          <div className="bottom-label">SENS ARCHEȚĂ</div>
          <div className="bottom-value">{machineLive.sens || 'S'}</div>
        </div>

        <div className="bottom-box">
          <div className="bottom-label">ÎNTINDERE TRAGERE</div>
          <div className="bottom-value yellow">
            {machineLive.TORQE_ACT_PERCENTEC || '25'} %
          </div>
        </div>

        <div className="bottom-box">
          <div className="bottom-label">PAS ETALARE</div>
          <div className="bottom-value yellow">
            {machineLive.TRAVERSE_CABLES_DIA || '8.0'} mm
          </div>
        </div>
      </div>
    </div>
  );
};

const DTB1250LimiteEtalarePage = ({ machineLive = {}, setPage }) => {
  return (
    <div className="dtb-limite-container">
      {/* TOP BAR (păstrăm aceeași structură ca Home) */}
      <div className="dtb-topbar">
        <div className="dtb-top-item">
          <div className="top-label">VEZI MAX LIN</div>
          <div className="top-value cyan">
            {machineLive.MAX_RAMP_VALUE_PER || '144.0'} m/min
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">VITEZA LIN</div>
          <div className="top-value green">
            {machineLive.ACT_RAMP_VALUE_PER || '2.0'} m/min
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">RĂSUCIRE</div>
          <div className="top-value">
            {machineLive.BOW_ACT_TWIST.toFixed(2) || '0.0'} rot/min
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">CUPLU</div>
          <div className="top-value yellow">
            {machineLive.TORQE_ACT_PERCENTEC || '25.0'} %
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">ETALARE ACT</div>
          <div className="top-value">{machineLive.TRAVERS_ACT_PULS} mm</div>
        </div>

        <div className="dtb-top-item set-box">
          <div className="top-label">SET M</div>
          <div className="top-value yellow">
            {machineLive.SET_METER || '30000.0'}
          </div>

          <div className="set-row">
            <span>ACT M</span>
            <strong>{machineLive.METER_ACT.toFixed(2) || '19763.1'}</strong>
          </div>

          <div className="set-row">
            <span>TOT M</span>
            <strong>{machineLive.METER_TOTAL.toFixed(2) || '19763.1'}</strong>
          </div>
        </div>
      </div>

      {/* MAIN AREA */}
      <div className="dtb-limite-main">
        {/* STÂNGA - LIMITĂ ETALARE */}
        <div className="limite-box">
          <div className="limite-title">LIMITĂ ETALARE</div>

          <div className="limite-row">
            <div className="limite-col">
              <div className="limite-label">STÂNGA</div>
              <div className="limite-value yellow">
                -{machineLive.TRAVERS_LEFT_PULS_LIMIT || '181'}
              </div>
            </div>

            <div className="limite-col">
              <div className="limite-label">ACT</div>
              <div className="limite-value cyan">
                {machineLive.TRAVERS_ACT_PULS || '0'}
              </div>
            </div>

            <div className="limite-col">
              <div className="limite-label">DREAPTA</div>
              <div className="limite-value yellow">
                {machineLive.TRAVERS_RIGHT_PULS_LIMIT || '157'}
              </div>
            </div>
          </div>
        </div>

        {/* DREAPTA - CONTOR */}
        <div className="contor-box">
          <div className="contor-title">CONTOR</div>

          <div className="contor-row yellow">
            <span>SETAT</span>
            <strong>{machineLive.SET_METER || '30000.0'} m</strong>
          </div>

          <div className="contor-row cyan">
            <span>ACT</span>
            <strong>{machineLive.METER_ACT.toFixed(2) || '19763.1'} m</strong>
          </div>

          <div className="contor-row cyan">
            <span>TOTAL</span>
            <strong>{machineLive.METER_TOTAL.toFixed(2) || '19763.1'} m</strong>
          </div>

          <div className="contor-row yellow">
            <span>COEF.</span>
            <strong>{machineLive.coef || '1.00000'}</strong>
          </div>

          <div className="contor-buttons">
            <button className="contor-btn">ACT RESET</button>
            <button className="contor-btn gray">CONTOR OPRIT</button>
            <button className="contor-btn">TOTAL RESET</button>
          </div>
        </div>
      </div>

      {/* BUTON HOME */}
      <div className="home-btn" onClick={() => setPage('HOME')}>
        🏠
      </div>
    </div>
  );
};

const DTB1250SettingsPage = ({ machineLive = {}, setPage }) => {
  const motors = [
    { id: 1, label: 'Motor 1', state: machineLive.PAY_OFF_1_TO_NOT_START },
    { id: 2, label: 'Motor 2', state: machineLive.PAY_OFF_2_TO_NOT_START },
    { id: 3, label: 'Motor 3', state: machineLive.PAY_OFF_3_TO_NOT_START },
    { id: 4, label: 'Motor 4', state: machineLive.PAY_OFF_4_TO_NOT_START },
    { id: 5, label: 'Motor 5', state: machineLive.PAY_OFF_5_TO_NOT_START },
    { id: 6, label: 'Motor 6', state: machineLive.PAY_OFF_6_TO_NOT_START },
    { id: 7, label: 'Motor 7', state: machineLive.PAY_OFF_7_TO_NOT_START }
  ];

  return (
    <div className="dtb-container">
      {/* TOP BAR IDENTIC HOME */}
      <div className="dtb-topbar">
        <div className="dtb-top-item">
          <div className="top-label">VEZI MAX LIN</div>
          <div className="top-value cyan">
            {machineLive.MAX_RAMP_VALUE_PER || '144.0'} m/min
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">VITEZA LIN</div>
          <div className="top-value green">
            {machineLive.ACT_RAMP_VALUE_PER || '2.0'} m/min
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">RĂSUCIRE</div>
          <div className="top-value">
            {machineLive.BOW_ACT_TWIST.toFixed(2) || '0.0'} rot/min
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">CUPLU</div>
          <div className="top-value yellow">
            {machineLive.TORQE_ACT_PERCENTEC || '25.0'} %
          </div>
        </div>

        <div className="dtb-top-item">
          <div className="top-label">ETALARE ACT</div>
          <div className="top-value">{machineLive.TRAVERS_ACT_PULS} mm</div>
        </div>

        <div className="dtb-top-item set-box">
          <div className="top-label">SET M</div>
          <div className="top-value yellow">
            {machineLive.SET_METER || '30000.0'}
          </div>

          <div className="set-row">
            <span>ACT M</span>
            <strong>{machineLive.METER_ACT.toFixed(2) || '19763.1'}</strong>
          </div>

          <div className="set-row">
            <span>TOT M</span>
            <strong>{machineLive.METER_TOTAL.toFixed(2) || '19763.1'}</strong>
          </div>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="dtb-settings-grid">
        {/* LEFT = MOTORS */}
        <div className="settings-left">
          <div className="settings-title">CONTROL MOTOARE</div>

          <div className="motor-grid">
            {motors.map(m => (
              <div key={m.id} className="motor-card">
                <div className="motor-label">{m.id}</div>

                <div className={`motor-light ${m.state ? 'on' : 'off'}`}>
                  {m.state ? 'ON' : 'OFF'}
                </div>
              </div>
            ))}
          </div>

          <div className="warning-box">RUPERE FIR OPRIRE</div>
        </div>

        {/* RIGHT = STATUS PANEL */}
        <div className="settings-right">
          <div className="status-box">STATUS LINIE</div>

          <div className="status-row">
            Linie activă: <b>{machineLive.lineActive ? 'DA' : 'NU'}</b>
          </div>

          <div className="status-row">
            Avarie: <b>{machineLive.alarm ? 'DA' : 'NU'}</b>
          </div>

          <div className="status-row">
            Operator OK: <b>{machineLive.operatorOk ? 'DA' : 'NU'}</b>
          </div>
        </div>
      </div>

      {/* HOME */}
      <div className="settings-home">
        <button className="home-btn" onClick={() => setPage('HOME')}>
          🏠
        </button>
      </div>
    </div>
  );
};

export default DTB1250Hmi;
